module.exports = __webpack_public_path__ + "img/guide04.290a5b82.png";